module.exports = __webpack_public_path__ + "nav-arrow-with-shadow.3ZzgDDHY.png";